// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-btn[data-v-21378397]{text-transform:none!important}.v-btn[data-v-21378397]:focus:after,.v-btn[data-v-21378397]:focus:before,.v-btn[data-v-21378397]:hover:after,.v-btn[data-v-21378397]:hover:before{background-color:transparent}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
